import { NgModule } from '@angular/core';
import { LocalizationPipe } from './localization.pipe';
import { LocalizationDirective } from './localization.directive';

@NgModule({
  declarations: [
    LocalizationPipe,
    LocalizationDirective
  ],
  exports: [
    LocalizationPipe,
    LocalizationDirective
  ],
  providers: [
    
  ]
})
export class LocalizationModule {
}
